import { LockIcon, PremiumIcon } from "@/assets/icons";
import Badge from "@/components/ui/badge";
import Divider from "@/components/ui/Divider";
import { DatasetExploreItem } from "@/types/dataset";

import { twMerge } from "tailwind-merge";

import { DatasetCardHeader } from "./datasetCardHeader";
import { DatasetCardSpatialInfo } from "./datasetCardSpatialInfo";

type Props = {
  index?: number;
  data: DatasetExploreItem;
  isSelected: boolean;
  isUseNewDatasetExplorerModal?: boolean;
  handleSelectData: (data: DatasetExploreItem) => void;
};

const DatasetCard = ({
  index,
  data,
  isSelected,
  isUseNewDatasetExplorerModal,
  handleSelectData
}: Props) => {
  const isPremium = isUseNewDatasetExplorerModal && data.license === "premium";
  const isLocked = isUseNewDatasetExplorerModal && !data.is_subscribed;

  return (
    <div
      className={twMerge(
        "flex flex-col font-sans border-[1px] rounded-lg p-4 gap-2 min-w-[266px] h-[144px] cursor-pointer justify-between relative",
        isSelected ? "bg-teal-50 border-teal-200" : "bg-white border-gainsboro"
      )}
      role="button"
      onClick={() => handleSelectData(data)}
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleSelectData(data)}
      // Onboarding tour anchor. The explore-dataset mock fixture places the tour's
      // target dataset first (index 0), so the spotlight and auto-click land on it.
      data-tourid={index === 0 ? "dataset-card-explorer" : undefined}
    >
      <DatasetCardHeader
        showLogo={isUseNewDatasetExplorerModal}
        titleClassName={isLocked ? "pr-7" : ""}
        datasetName={data.name}
        logoUrl={data.provider?.logo_asset_url}
        shortDescription={data.short_description}
      />
      <div className="flex flex-col gap-1">
        <Divider className="bg-gainsboro w-full h-[1px]" />
        <DatasetCardSpatialInfo
          spatialType={data.spatial_aggregation_type}
          countryId={data.country_id}
          rightContent={
            <div className="flex items-center gap-2">
              <span className="text-[10px] text-grey">
                {data.provider?.name}
              </span>
              {isPremium && (
                <Badge className="bg-solid-green border-solid-green rounded-[4px] flex items-center justify-center">
                  <PremiumIcon
                    className="fill-white"
                    aria-label="Premium dataset"
                    title="Premium dataset"
                  />
                </Badge>
              )}
            </div>
          }
        />
      </div>
      {isLocked && (
        <Badge className="absolute top-0 right-4 bg-[#E37900] border-[#E37900] rounded-tr-none rounded-tl-none p-1">
          <LockIcon
            className="fill-white"
            aria-label="Locked dataset"
            title="Locked dataset"
          />
        </Badge>
      )}
    </div>
  );
};

export default DatasetCard;
